export default class FaceModal {
  constructor({ modalEl }) {
    this._modalEl = modalEl;

    this._imageEl = modalEl.querySelector(".face-modal__image");
    this._nameEl = modalEl.querySelector(".face-modal__name");
    this._cityEl = modalEl.querySelector(".face-modal__city");
    this._roleEl = modalEl.querySelector(".face-modal__role");
    this._contentContainerEl = modalEl.querySelector(
      ".face-modal__content-container"
    );

    this._body = document.querySelector("body");

    this._contentRowTemplate = document.querySelector(
      "#face-modal-content-row-template"
    ).content.firstElementChild;

    this._closeBtn = modalEl.querySelector(".face-modal__close");

    this._setEventListeners();

    // bindings
    this._handleEscClose = this._handleEscClose.bind(this);
    this._handleOverlayClose = this._handleOverlayClose.bind(this);
  }

  _setEventListeners() {
    this._closeBtn.addEventListener("click", () => {
      this.close();
    });
  }

  _handleEscClose(e) {
    if (e.key === "Escape") {
      this.close();
    }
  }

  _handleOverlayClose(e) {
    console.log(this);
    if (e.target.classList.contains("face-modal--open")) {
      this.close();
    }
  }

  _generateContentRow(heading, content) {
    const contentRow = this._contentRowTemplate.cloneNode(true);
    const headingEl = contentRow.querySelector(".js-content-row-heading");
    const textContainerEl = contentRow.querySelector(".js-content-row-text");

    headingEl.textContent = heading;
    textContainerEl.innerHTML = content;

    return contentRow;
  }

  hydrate({ name, city, role, imageSrc, contentRows }) {
    this._nameEl.textContent = name;
    this._cityEl.textContent = city;
    this._roleEl.textContent = role;
    this._imageEl.src = imageSrc;
    this._imageEl.alt = name;

    contentRows.forEach(({ label, value }) => {
      const rowEl = this._generateContentRow(label, value);
      this._contentContainerEl.append(rowEl);
    });
  }

  _cleanup() {
    this._nameEl.textContent = "";
    this._cityEl.textContent = "";
    this._roleEl.textContent = "";
    this._imageEl.src = "";
    this._imageEl.alt = "";

    this._contentContainerEl.innerHTML = "";
  }

  show() {
    this._modalEl.classList.add("face-modal--loaded");
  }

  open() {
    this._body.classList.add("no-scroll");
    this._modalEl.classList.add("face-modal--open");
    document.addEventListener("keydown", this._handleEscClose);
    document.addEventListener("click", this._handleOverlayClose);
  }

  close() {
    this._modalEl.classList.remove("face-modal--open");
    this._modalEl.classList.remove("face-modal--loaded");
    this._body.classList.remove("no-scroll");
    document.removeEventListener("keydown", this._handleEscClose);
    document.removeEventListener("click", this._handleOverlayClose);
    setTimeout(() => {
      this._cleanup();
    }, 200);
  }
}
